import React from "react";
import { Input, TextArea, GroupByPanelContent } from "@aidkitorg/component-library";
import { GroupByConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useLocalizedStrings } from "../../../Localization";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type SummaryTableFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  groupByConfig: GroupByConfig,
  onGroupByChange: (config: GroupByConfig) => void,
}

export const SummaryTableFormFields: React.FC<SummaryTableFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  groupByConfig, onGroupByChange,
}) => {
  const L = useLocalizedStrings()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()

  return <>
    <Input 
      required
      label="Table Title"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    
    {/* What we're measuring */}
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.summary_table_measuring}
      </label>
      <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border">
        📊 <strong>{L.admin_panel.dashboards.applicant_count}</strong> - {L.admin_panel.dashboards.summary_table_measuring_desc}
      </div>
    </div>
    
    {/* Group By Columns */}
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.group_by_cols}
      </label>
      <p className="text-xs text-gray-500">
        {L.admin_panel.dashboards.group_by_cols_desc}
      </p>
      
      <GroupByPanelContent
        compact
        hideSortDirection
        value={groupByConfig}
        onChange={onGroupByChange}
        availableFields={fieldOptions.map(option => ({
          key: option.value,
          label: String(option.label),
          type: 'text' as const
        }))}
        className="border p-2"
      />
    </div>
        
    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}